export enum GenericDataEventObject {
  INFOBUBBLE = 'infobubble',
  TIMESTAMP = 'timestamp',
  INFOBOX_LEARN_MORE = 'infobox_learn_more',
}
